'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBemReact = require('@yandex-lego/i-bem-react');

exports.default = (0, _iBemReact.decl)({
    block: 'copyright',
    elem: 'link',
    tag: 'a',
    attrs: function attrs(_ref) {
        var href = _ref.url;

        return { href: href };
    }
});